export const Sections = {
  WELCOME: 'welcome',
  EVALUATIONS: 'evaluations',
  MEDICATIONS: 'medications',
  OPEN_SESSION: 'open-session',
  CLOSE_SESSION: 'close-session',
};

export const subsections = {
  IMPORTANT_INFORMATION: 'important-information',
  DOUBLE_CHECK_IDS: 'double-check-ids',
  TREATMENT_PLAN: 'treatment-plan',
};

export const subsectionsWithoutId = {
  IMPORTANT_INFORMATION: 'important-information',
  DOUBLE_CHECK_IDS: 'double-check-ids',
};

export const MEMBER_ACTIONS = {
  PROFILE: 'profile',
  AMA: 'ama',
  SCHEDULE: 'schedule',
  CHAT: 'chat',
};
